import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NotificationsHttpService} from '../../../../services/http-services/notifications/notifications-http.service';
import {UserRole} from '../../../../enums/general-enums';
import {ToastrService} from 'ngx-toastr';
import {DatePickerModule} from '../../../../shared-components/date-picker/date-picker.module';
import {MatFormField} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {FormControlErrorMessagesModule} from '../../../../pipes/form-control-error-messages/form-control-error-messages.module';
import {UsersHttpService} from "../../../../services/http-services/users/users-http.service";
import {DaysOfWeek} from "../../../../constants/general-variables";
import {SearchModule} from "../../../../shared-components/search/search.module";
import {LoaderComponent} from "../../../../shared-components/loader/loader.component";

@Component({
  selector: 'gr-create-notification-modal',
  standalone: true,
  templateUrl: './create-notification-modal.component.html',
  imports: [
    ReactiveFormsModule,
    DatePickerModule,
    MatFormField,
    MatInput,
    NgxMaterialTimepickerModule,
    FormControlErrorMessagesModule,
    NgIf,
    NgForOf,
    SearchModule,
    LoaderComponent
  ],
  providers: [DatePipe]
})
export class CreateNotificationModalComponent {
  createCustomNotificationForm!: FormGroup;
  formTriedToSubmit = false;
  imageUrl = '';
  initialImage: any;
  @Input() notificationForEdit: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmCreateNotification: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmEditNotification: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  protected readonly UserRole = UserRole;
  usersList: any[] = [];
  selectedUserIds: number[] = [];
  urlParams: any = {search: null};
  selectedRole = '';
  isLoaderActive = false;
  isToggleActive = true;

  constructor(private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private datePipe: DatePipe,
              private notificationsHttpService: NotificationsHttpService,
              private usersHttpService: UsersHttpService,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.createCustomNotificationForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      notificationDate: ['', Validators.required],
      notificationTime: ['', Validators.required],
      role: ['', Validators.required],
      users: [[], Validators.required]
    });
    if (this.notificationForEdit) {
      console.log('this.notificationForEdit', this.notificationForEdit)
      this.createCustomNotificationForm.patchValue(this.notificationForEdit);
      this.createCustomNotificationForm.controls.notificationDate.patchValue(this.notificationForEdit.release_date.slice(0, 10));
      this.createCustomNotificationForm.controls.notificationTime.patchValue(this.notificationForEdit.release_date.slice(11, -3));
      this.initialImage = this.notificationForEdit?.image;

      this.createCustomNotificationForm.controls.users.patchValue(this.notificationForEdit.users.map((user:any) => user.id));

      if (this.notificationForEdit.users.some((user: any) => user.role?.name === 'business')) {
        this.selectedRole = 'business';
      } else {
        this.selectedRole = 'user'
      }

      setTimeout(() => {
        this.createCustomNotificationForm.patchValue({ role: this.selectedRole });
      });
      this.getUsers(this.selectedRole);
    }
  }


  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
      this.toastrService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
      return;
    } else if (file?.size > 10485760) {
      this.toastrService.warning(`Slika ${file.name} je veća od 10MB.`);
      return;
    } else {
      this.createCustomNotificationForm.controls.image.patchValue(file);
      this.imageUrl = URL.createObjectURL(file);
      this.fileInput.nativeElement.value = '';
    }
  }

  removeFile(): void {
    this.createCustomNotificationForm.controls.image.patchValue(null);
    this.imageUrl = '';
    if (this.initialImage)  {
      this.createCustomNotificationForm.controls.deleted_images_id.patchValue(this.initialImage.id);
    }
  }

  onSelectedDate(selectedDate: any): void {
    this.createCustomNotificationForm.controls.notificationDate.patchValue(this.datePipe.transform(selectedDate, 'yyyy-MM-dd'));
  }

  submitCustomNotificationForm(): void {
    this.isLoaderActive = true;
    this.formTriedToSubmit = true;

    if (this.createCustomNotificationForm.valid) {
      const {notificationDate, notificationTime, ...restForm} = this.createCustomNotificationForm.value;
      const isSendAll = this.usersList.length === this.selectedUserIds.length;
      const requestBody = {
        ...restForm,
        release_date: `${notificationDate} ${notificationTime}`,
        ...(isSendAll ? { send_all: true } : {send_all: false}),
        ...(isSendAll ? {users: []} : {users: this.selectedUserIds})
      };

      this.notificationForEdit
        ? this.notificationsHttpService.editCustomNotification({notificationId: this.notificationForEdit.id}, requestBody).then((res: any) => {
          this.toastrService.success('Uspešno ste izmenili notifikaciju.');
          this.isLoaderActive = false;
          this.confirmEditNotification.emit(res);
        }, (error: any) => {
          this.isLoaderActive = false;
          this.toastrService.success(error.message);
        })
        : this.notificationsHttpService.createCustomNotification(requestBody).then((res: any) => {
          this.toastrService.success('Uspešno ste kreirali notifikaciju.');
          this.isLoaderActive = false;
          this.confirmCreateNotification.emit(res);
        }, (error: any) => {
          this.isLoaderActive = false;
          this.toastrService.success(error.message);
        });
    } else {
      this.isLoaderActive = false;
    }
  }

  getUsers(role: string, urlParams?: {search: string}): void {
    this.usersHttpService.getAllUsers(role, urlParams).then((res: any) => {
      this.usersList = res;
      if (this.notificationForEdit !== null) {
        this.selectedUserIds = this.notificationForEdit.users.filter((user: any) => user.role?.name === this.selectedRole).map((user: any) => user.id);
        this.isToggleActive = !!this.selectedUserIds.length;
      } else {
        // this.selectedUserIds = this.usersList.map(user => user.id);
        if (this.isToggleActive && !this.selectedUserIds.length) {
          this.selectedUserIds = [...this.usersList.map(user => user.id)];
          this.createCustomNotificationForm.controls.users.patchValue(this.selectedUserIds);
        }
      }
      this.createCustomNotificationForm.patchValue({
        ids: [...this.selectedUserIds]
      });
    });
  }

  get shouldShowUserList(): boolean {
    return !!this.createCustomNotificationForm.get('role')?.value;
  }

  onRoleChange(role: string) {
    this.selectedRole = role;
    this.selectedUserIds = [];
    this.getUsers(this.selectedRole);
  }

  onCheckboxChange(event: Event, userId: number) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    if (isChecked) {
      if (!this.selectedUserIds.includes(userId)) {
        this.selectedUserIds.push(userId);
      }
    } else {
      this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);
    }

    this.createCustomNotificationForm.patchValue({
      users: [...this.selectedUserIds]
    });
  }

  toggleSelectAll() {
    if (this.selectedUserIds.length) {
      this.isToggleActive = false;
      this.selectedUserIds = [];
    } else {
      this.isToggleActive = true;
      this.selectedUserIds = [...this.usersList.map(user => user.id)];
    }
    this.createCustomNotificationForm.patchValue({
      users: [...this.selectedUserIds]
    });
  }

  areAllSelected(): boolean {
    return this.usersList.length > 0 &&
      this.usersList.every(user => this.selectedUserIds.includes(user.id));
  }

  onSearchChange(searchQuery: string): void {
    this.urlParams.search = searchQuery;
    this.getUsers(this.selectedRole, this.urlParams);
  }

  protected readonly daysOfWeek = DaysOfWeek;
}
